import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Action, TableColumn } from '../../models/common.model';
import { PurchaseOrder } from '../../../purchased-order/purchased-order.model';

@Component({
  selector: 'app-table',
  standalone: false,
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent<T> implements OnInit, OnDestroy {
  @Input() columns: TableColumn<T>[] = [];
  @Input() data: (T & { entries?: any; raw_material_consumptions?: any[] })[] = [];
  @Input() actions: Action[] = [];

  @Output() onView = new EventEmitter<T>();
  @Output() onDelete = new EventEmitter<T>();
  @Output() onDownload = new EventEmitter<T>();
  @Output() onEdit = new EventEmitter<T>();
  @Output() onClickAddEntry = new EventEmitter<T>();
  @Output() onClickSalarySheet = new EventEmitter<T>();
  @Output() onClickAdjust = new EventEmitter<T>();

  constructor() {}

  ngOnInit(): void {
    console.log('ngOnInit -> ', this.columns);
  }

  getValue(row: T, field: string): any {
    return field.split('.').reduce((acc: any, part: string) => acc?.[part], row);
  }

  emit(action: Action, row: T): void {
    if (action === Action.VIEW) this.onView.emit(row);
    if (action === Action.DELETE) this.onDelete.emit(row);
    if (action === Action.DOWNLOAD) this.onDownload.emit(row);
    if (action === Action.EDIT) this.onEdit.emit(row);
  }

  getBooleanValue(data: any, field: any): boolean {
    return data[field];
  }

  ngOnDestroy(): void {}

  protected readonly Action = Action;
}
